// Truncate text on Suggested Articles, Suggested Events, etc
export default function capitalize(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}
